/**
 * Constantes de configuração da API.
 */

/** Caminho base da API */
export const API_BASE_PATH = typeof window !== 'undefined' && !!(window as unknown as Record<string, unknown>).__TAURI_INTERNALS__ && process.env.NODE_ENV === 'production'
  ? `${process.env.NEXT_PUBLIC_API_URL?.replace(/\/$/, '') || 'https://7days-gateway-production.up.railway.app'}/api`
  : "/api";

/** Timeout padrão para requisições HTTP (em milissegundos) */
export const API_TIMEOUT_MS = 60000;

/** Duração padrão do toast de notificação (em milissegundos) */
export const TOAST_DEFAULT_DURATION_MS = 5000;
